import { default as occurrence } from './occurrence/routes'
import { default as occurrence_sheet } from './occurrence_sheet/routes'
import { default as occurrence_type } from './occurrence_type/routes'
import { default as occurrence_validate } from './occurrence_validate/routes'
import { default as print } from './print/routes'
import { default as occurrence_motive } from './occurrence_motive/routes'
import { default as teacher_time_bank } from './teacher_time_bank/routes'

export default [
    ...occurrence,
    ...occurrence_sheet,
    ...occurrence_type,
    ...occurrence_validate,
    ...print,
    ...occurrence_motive,
    ...teacher_time_bank
]